/*
**    저장버튼에서 구독 
** questionItemsSplit에서 포인트변경, 추가 삭제시 dispatch
*/
import { JumpExampleCountProps } from 'gql/jump_example_count'

// 전체 데이터 저장
export const INIT = 'survey/create/logic/jumpExampleCount/INIT'

// 개별문항 및 페이지의 row 추가 삭제 변경시 저장
export const CHANGE = 'survey/create/logic/jumpExampleCount/CHANGE'

// 여러 문항 연결 한 번에 바꾸기 (완료글 일괄 연결, 섹션별로 그려서 아직 안 연 섹션 문항도 바로 바꿔야 저장에 들어간다)
export const CHANGE_MANY = 'survey/create/logic/jumpExampleCount/CHANGE_MANY'

const initState: { rows: JumpExampleCountProps[] } = {
    rows: []
}

interface ActionProps {
    type: string;
    O_INIT: {
        rows: JumpExampleCountProps[]; // 점프로직 포인트 초기 데이터 저장
    },
    O_CHANGE: {
        survey_question_no: number;
        rows: JumpExampleCountProps[]; // 문항 및 페이지별 rows 데이터값이다 변경 (추가, 삭제, Else 값 변경시 사용)
    },
    O_CHANGE_MANY: {
        survey_question_nos: number[];
        rows: JumpExampleCountProps[];
    }
}

export default (state = initState, action: ActionProps) => {
    switch(action.type) {
        case INIT:
            const { O_INIT } = action

            return {
                rows: O_INIT.rows
            }
        case CHANGE:
            const { O_CHANGE } = action

            return {
                rows: [
                    ...state.rows.filter(c => c.survey_question_no !== O_CHANGE.survey_question_no),
                    ...O_CHANGE.rows
                ]
            }
            
        case CHANGE_MANY: {
            const targets = new Set(action.O_CHANGE_MANY.survey_question_nos)
            return {
                rows: [
                    ...state.rows.filter(c => !targets.has(c.survey_question_no)),
                    ...action.O_CHANGE_MANY.rows
                ]
            }
        }
        default:
            return state
    }
}